import { useState } from 'react';
import {
  formatDate,
  formatTimeRange,
} from '@purple-start-registration/common/dates';
import { strings } from '@purple-start-registration/common/localization';

import { formatHTML } from '../../../common/price';

export function SelectionDate({ config, language, onChange }) {
  const { settings, sessions } = config;

  const [checkedState, setCheckedState] = useState(
    new Array(sessions.length).fill(false)
  );

  const handleOnChange = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    setCheckedState(updatedCheckedState);

    if (onChange) {
      onChange(
        updatedCheckedState
          .map((selected, index) => selected && sessions[index])
          .filter((session) => !!session)
      );
    }
  };

  return (
    <fieldset>
      <div>
        <legend className="text-base font-medium text-gray-900">
          {strings.sessionsByDateTitle}
        </legend>
        <p
          className="mt-1 text-sm text-gray-700"
          dangerouslySetInnerHTML={{
            __html: strings.formatString(
              strings.sessionsByDateDescription,
              formatHTML(settings.session_price),
              settings.discount_min_sessions,
              formatHTML(settings.discounted_session_price)
            ),
          }}
        />
      </div>
      <div className="mt-4 space-y-4">
        {sessions.map((session, index) => (
          <div key={session.date} className="relative flex items-start">
            <div className="flex items-center h-5">
              <input
                id={session.dateISO}
                type="checkbox"
                name={session.dateISO}
                checked={checkedState[index]}
                disabled={session.full}
                className="focus:ring-purple-500 h-4 w-4 text-purple-600 border-gray-300 rounded"
                onChange={() => handleOnChange(index)}
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor={session.dateISO} className="text-gray-700">
                {(session.full && (
                  <span className="text-gray-500">
                    {formatDate(session.date, language)}&nbsp;
                    <span className="text-gray-400">
                      ({strings.fullyBooked})
                    </span>
                  </span>
                )) || (
                  <>
                    {formatDate(session.date, language)}&nbsp;
                    <span>
                      (
                      <strong>
                        {formatTimeRange(session.start, session.end, language)}
                      </strong>
                      )
                    </span>
                  </>
                )}
              </label>
            </div>
          </div>
        ))}
      </div>
    </fieldset>
  );
}
